import React, { useEffect, useRef, useState } from 'react';
import { deleteBlogDetailById, getBlogDetailAll, SaveBlogDetail } from '../../../_services';
import Layout from '../../shared/Layout';
import DataTable from 'react-data-table-component';
import { imageurl } from '../../../_config';
import ReactQuill from 'react-quill'; import 'react-quill/dist/quill.snow.css';
import { Modal } from 'react-bootstrap';
import { resizeImage } from '../../../_services/resizeImage';
import { ToastContainer, toast } from 'react-toastify';

const Blog = () => {
    const [isFormopen, setIsFormopen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [blogId, setblogId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({
        blogId: 0,
        blogImage: "",
        blogTitle: '',
        blogDescrption: '',
        blogDate: new Date(),
        file: "",
        createdBy: 0,
        isActive: true
    });

    const getShortDescription = (description, wordLimit) => {
        if (!description) return '';
        const text = description.replace(/<\/?[^>]+(>|$)/g, "").trim();
        const words = text.split(/\s+/);
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(' ') + '...'
            : words.join(' ');
    };

    const handleModalToggle = (index) => {
        setActiveIndex(index);
        setShowModal(!showModal);
    };

    const handleDescriptionChange = (value) => {
        setFormData(prev => ({
            ...prev,
            blogDescrption: value
        }));
    };

    const handleChange = async (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'file' && files[0]) {
            const file = files[0];

            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                const image = new Image();
                image.src = URL.createObjectURL(file);

                image.onload = async () => {
                    try {
                        const resizedFile = await resizeImage(file, 1076, 628);
                        setFormData((prevState) => ({
                            ...prevState,
                            [name]: resizedFile
                        }));
                    } catch (err) {
                        toast.error('Error resizing the image.');
                    }
                };
            } else {
                toast.error('Only JPEG and PNG images are allowed.');
            }
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const fetchBlogDetailAll = async () => {
        try {
            const data = await getBlogDetailAll();
            setBlogData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    const sortedData = data?.sort((a, b) => {
                        return new Date(b.createdDate) - new Date(a.createdDate);
                    });

                    return sortedData;
                }
                return prevData;
            })
        } catch (error) {
            // toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const onSave = async (e) => {
        e.preventDefault();
        try {
            const data = await SaveBlogDetail(formData);
            if (data.isSuccess === 200) {
                toast.success("Save Successfully");
                handleReset();
                setIsFormopen(false);
                fetchBlogDetailAll();
            }

        } catch (error) {
            // toast.error("Please try again later.");
        }
    };

    const onEdit = (item) => {
        setblogId(item?.blogId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            blogId: item?.blogId,
            blogDescrption: item?.blogDescrption,
            blogTitle: item?.blogTitle,
            blogDate: item?.blogDate,
            file: null,
            isActive: item?.isActive
        })
    }
    const handleReset = () => {
        setFormData({
            blogId: 0,
            blogImage: null,
            blogTitle: '',
            blogDescrption: '',
            blogDate: new Date(),
            file: null,
            createdBy: 0,
            isActive: true
        });
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const onDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await deleteBlogDetailById(id);
        if (data.isSuccess === 1) {
            fetchBlogDetailAll();
            toast.success("Delete Successfully");
        }
    };

    const onOpen = () => {
        setblogId(null)
        handleReset();
        setIsFormopen(true)
    }

    useEffect(() => {
        fetchBlogDetailAll();
    }, [])

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Image',
            selector: row => row.blogImage ? <img src={`${imageurl}${row?.blogImage}`} alt="" width="50" /> : 'No Image',
            sortable: false,
            width: '100px',
        },
        {
            name: 'Blog Title',
            selector: row => row.blogTitle,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Description',
            selector: (row, index) => (
                <div >
                    <p style={{ cursor: 'pointer' }} className='mb-0 blog_description' onClick={() => handleModalToggle(index)}>{getShortDescription(row?.blogDescrption, 15)}...</p>
                </div>
            ),
            sortable: true,
            width: '280px'
        },
        {
            name: 'Blog Date',
            selector: row => {
                if (row.blogDate) {
                    const date = new Date(row.blogDate);

                    // Convert to Indian Standard Time (IST)
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    // Format Date as dd/mm/yyyy
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
                    const year = indianTime.getFullYear();

                    // Format Time as hh:mm:ss
                    // const hours = String(indianTime.getHours()).padStart(2, '0');
                    // const minutes = String(indianTime.getMinutes()).padStart(2, '0');
                    // const seconds = String(indianTime.getSeconds()).padStart(2, '0');

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: true,
            width: '180px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' onClick={() => onEdit(row)} className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title='Delete' onClick={() => onDelete(row.blogId)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];


    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            ['link'],
            ['image']
        ],
    };

    // const modules = {
    //     toolbar: [
    //       [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
    //       [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    //       ['bold', 'italic', 'underline'],
    //       ['link'],
    //       [{ 'align': [] }],
    //       ['image'],
    //       ['clean']
    //     ],
    //     clipboard: {
    //       matchVisual: false
    //     }
    //   };

    return (
        <Layout>
            <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Create New Blog Post</h4>
                    </div>
                    <div className="add_btn">
                        <button onClick={onOpen}>Add New Blog</button>
                    </div>
                </div>


                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={blogData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={() => setIsFormopen(false)} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add New Blog</h4>
                        </div>
                        <form onSubmit={onSave}>

                            <div className="form-group">
                                <label htmlFor="formFile">Title</label>
                                <input type="text" className="form-control" id="blogTitle" name="blogTitle" value={formData.blogTitle} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="formFile">Descriprion {`(Max Limit: 500 Characters)`}</label>
                                <ReactQuill
                                    value={formData.blogDescrption}
                                    onChange={handleDescriptionChange}
                                    modules={modules}
                                    theme="snow"
                                    placeholder="Enter description here"
                                    name='blogDescrption'
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="formFile">File{`(1076*628px)`}</label>
                                <input type="file" className="form-control" id="file" name="file" accept="image/png, image/jpeg" onChange={handleChange} ref={fileInputRef} />
                            </div>


                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">{blogId ? 'Update' : 'Submit'}</button>
                                </div>
                                <div className="reset-btn pt-2">
                                    <button type='button' className="" onClick={handleReset}>Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Modal */}
            {activeIndex !== null && (
                <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    dialogClassName="modal-xl"
                    centered
                >
                    <Modal.Body>
                        <div className="popup_content">

                            <div className="description-box">
                                <div
                                    className="word-wrap"
                                    dangerouslySetInnerHTML={{ __html: blogData[activeIndex]?.blogDescrption }}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </Layout>

    );

};

export default Blog;